package com.zaurh.mapquizwebsite.utils

sealed interface Result<out T> {
    data class Success<T>(
        val data: T
    ) : Result<T>

    data class Error(
        val code: Int = 0,
        val message: String
    ) : Result<Nothing>
}

suspend fun <T : Any> Result<T>.onSuccess(
    executable: suspend (T) -> Unit
): Result<T> = apply {
    if (this is Result.Success<T>) {
        executable(data)
    }
}

suspend fun <T : Any> Result<T>.onError(
    executable: suspend (code: Int, message: String) -> Unit
): Result<T> = apply {
    if (this is Result.Error) {
        executable(code, message)
    }
}

